import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import AppSetup from "../core/AppSetup";

const apiUrl = AppSetup.getUserApiUrl();
axios.defaults.baseURL = apiUrl;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.headers.post['Content-Type'] = 'application/json';

const setToken = () => {
    const authToken = localStorage.getItem("AUTHTOKEN");
    axios.defaults.headers.common.AuthToken =  authToken ? authToken : "";
}

export const getIndex = createAsyncThunk(
    "get/index",
    async (_P: any, thunkAPI) => {
        setToken();
        try {
            return await axios.get("news/idx");
        } catch (error) { 
            return thunkAPI.rejectWithValue({error});
        }
});

export const getArticle = createAsyncThunk(
    "get/article",
    async (key: string, thunkAPI) => {
        setToken();
        try {
            return await axios.get("news/?" + key);
        } catch (error) { 
            return thunkAPI.rejectWithValue({error});
        }
});
